import React, { Component } from 'react'
import { InputSearchLayout, PageContainerLayout, PageHeaderLayout, PaginationLayout } from '../../../layouts'
import { ConciliationsHeaderTiles, ConciliationsTable } from '../../containers'
import { conciliationOperations } from '../../../../state/ducks/conciliations'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { ConciliationShape, PaginationShape } from '../../../../prop-types'

class ConciliationsPage extends Component {
  constructor (props) {
    super(props)

    this.state = {
      params: {}
    }
    this.fetchConciliations = this.fetchConciliations.bind(this)
    this.onPaginationChange = this.onPaginationChange.bind(this)
    this.onSearchChange = this.onSearchChange.bind(this)
    this.updateParams = this.updateParams.bind(this)
  }

  UNSAFE_componentWillMount () {
    this.fetchConciliations()
  }

  fetchConciliations () {
    this.props.fetchConciliations(this.state.params)
  }

  onPaginationChange (page) {
    this.updateParams('page', page)
  }

  onSearchChange (keywork) {
    this.updateParams('search', keywork)
  }

  updateParams (key, value) {
    const { params } = this.state
    params[key] = value
    if (key === 'search') {
      params.page = 1
    }
    this.setState({
      params
    }, () => this.fetchConciliations())
  }

  renderHeaderPaths () {
    return (
            <>
                <li>Conciliations</li>
            </>
    )
  }

  render () {
    return (
            <>
                <PageContainerLayout clientSidebar={true} showNavbarClientOptions={true}>
                    <PageHeaderLayout title={'Conciliations'} subTitle={'All conciliations'}
                                      paths={this.renderHeaderPaths}/>
                    {/* Page Content */}
                    <div className="content content-boxed">
                        {/* Header Tiles */}
                        <ConciliationsHeaderTiles all_conciliations={this.props.paginationData.totalItems}/>
                        {/* END Header Tiles */}
                        <div className={' block block-themed block-opt-refresh-icon7 ' + (this.props.isLoading ? ' block-opt-refresh ' : '')}>
                            <div className="block-header bg-primary-dark">
                                <ul className="block-options">
                                    <li>
                                        <button type="button" data-toggle="block-option"
                                                data-action="fullscreen_toggle">
                                            <i className="si si-size-fullscreen"/>
                                        </button>
                                    </li>
                                    <li>
                                        <button type="button"
                                                data-toggle="block-option"
                                                data-action="refresh_toggle"
                                                data-action-mode="demo"
                                                onClick={this.fetchConciliations}
                                        >
                                            <i className="si si-refresh"></i>
                                        </button>
                                    </li>
                                </ul>
                                <h3 className="block-title">All conciliations</h3>
                            </div>
                            <div className="block-content">
                                {/* Search */}
                                <InputSearchLayout onSearchChange={this.onSearchChange}/>
                                {/* End Search */}
                                {/* Table */}
                                <ConciliationsTable conciliations={this.props.conciliations} params={this.state.params}>
                                    {/* Pagination */}
                                    <PaginationLayout pagination={this.props.paginationData}
                                                      onPaginationChange={this.onPaginationChange}/>
                                    {/* End Pagination */}
                                </ConciliationsTable>
                                {/* End Table */}
                            </div>
                        </div>
                    </div>
                    {/* END Page Content */}
                </PageContainerLayout>
            </>
    )
  };
}

// Set propTypes
const { arrayOf, func } = PropTypes
ConciliationsPage.propTypes = {
  conciliations: arrayOf(ConciliationShape).isRequired,
  fetchConciliations: func.isRequired,
  paginationData: PaginationShape
}

// Set defaultProps
ConciliationsPage.defaultProps = {
  conciliations: [],
  paginationData: {}
}

// mapStateToProps
const mapStateToProps = (state) => ({
  isLoading: state.conciliations.fetchConciliationsReducer.loading,
  conciliations: state.conciliations.fetchConciliationsReducer.data.results,
  paginationData: state.conciliations.fetchConciliationsReducer.data.pagination_data
})

// mapStateToProps
const mapDispatchToProps = {
  fetchConciliations: conciliationOperations.list
}

// Export Class
const _ConciliationsPage = connect(mapStateToProps, mapDispatchToProps)(ConciliationsPage)
export { _ConciliationsPage as ConciliationsPage }
